exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NoDataIndicator_no_data_indicator{margin:auto;padding-top:20px;margin-bottom:20px;max-width:100px}.NoDataIndicator_no_data_indicator_text_container{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"no_data_indicator": "NoDataIndicator_no_data_indicator",
	"no_data_indicator_text_container": "NoDataIndicator_no_data_indicator_text_container"
};